import React from 'react';
import { PolarAngleAxis, PolarGrid, PolarRadiusAxis, Radar, RadarChart, ResponsiveContainer, Tooltip as ChartTooltip, Legend } from 'recharts';
import { SectionCard } from '../common/SectionCard';
import { criterionBenchmarks } from '../../data/analytics';
export function CriterionRadar() {
  const weakest = [...criterionBenchmarks].sort((a, b) => a.portfolio - a.benchmark - (b.portfolio - b.benchmark))[0];
  return <SectionCard title="Criterion performance vs benchmark" description="Portfolio mean score per criterion against the historical benchmark for successful records" data-id="element-353" data-mp="37pb6kqipi41i">
      <div className="h-64 w-full" data-id="element-354" data-mp="2xyynl2qjiixh">
        <ResponsiveContainer width="100%" height="100%" data-id="element-355" data-mp="2xxx367nmwk33">
          <RadarChart data={criterionBenchmarks} outerRadius="72%" data-id="element-356" data-mp="2t0f3l7vibh7r">
            <PolarGrid stroke="var(--border)" data-id="element-357" data-mp="3qh43ux4t6bf1" />
            <PolarAngleAxis dataKey="criterion" tick={{
            fontSize: 10,
            fill: 'var(--muted-foreground)'
          }} data-id="element-358" data-mp="3qhvnrap1mkph" />
            <PolarRadiusAxis domain={[40, 100]} tick={{
            fontSize: 9,
            fill: 'var(--muted-foreground)'
          }} axisLine={false} data-id="element-359" data-mp="2mjaq81o5g021" />
            <ChartTooltip contentStyle={{
            fontSize: 12,
            borderRadius: 4,
            border: '1px solid var(--border)'
          }} data-id="element-360" data-mp="2cu0xcjlhedcv" />
            <Legend wrapperStyle={{
            fontSize: 11
          }} data-id="element-361" data-mp="2hs2f917686mr" />
            <Radar name="Portfolio" dataKey="portfolio" stroke="var(--chart-1)" fill="var(--chart-1)" fillOpacity={0.22} data-id="element-362" data-mp="2hqrdt8177ayt" />
            <Radar name="Benchmark" dataKey="benchmark" stroke="var(--chart-3)" fill="var(--chart-3)" fillOpacity={0.16} data-id="element-363" data-mp="1tv53xahg6303" />
          </RadarChart>
        </ResponsiveContainer>
      </div>
      <p className="mt-2 text-[11px] leading-relaxed text-muted-foreground" data-id="element-364" data-mp="3o9pntkxy1uif">
        {weakest.criterion} is the weakest axis at {weakest.portfolio} against a benchmark of{' '}
        {weakest.benchmark} — the criterion most often responsible for records falling into the
        manual-review band.
      </p>
    </SectionCard>;
}